import { useSelector } from 'react-redux'
import { RootState } from '../../../store'
import { TAB_KEYS } from './consts'
import { useMemo } from 'react'
import {
  selectIsApplyGlobally,
  selectGlobalDraftFilters,
} from '../../../store/selectors/dataAnalysisSelectors'

const shared = {
  wheatCodeFilters: {
    filter: 'wheat_codes',
    messageField: 'Select at least one wheat code',
  },
  singleProductFilters: {
    filter: 'blend_type',
    messageField: 'Product must be selected',
  },
  productFilters: {
    filter: 'blend_types',
    messageField: 'Select at least one product',
  },
}

const ApplyInfo = Object.fromEntries([
  ...[
    TAB_KEYS.PARAMETERS_COMPARISON,
    TAB_KEYS.PARAMETERS_TREND,
    TAB_KEYS.CONSISTENCY_TREND,
    TAB_KEYS.BIN_DISTRIBUTION,
    TAB_KEYS.STORAGE_DISTRIBUTION,
  ].map((k) => [k, { ...shared.wheatCodeFilters }]),
  ...[TAB_KEYS.COMPOSITIONS].map((k) => [
    k,
    { ...shared.singleProductFilters },
  ]),
  ...[TAB_KEYS.COST_TRENDS].map((k) => [k, { ...shared.productFilters }]),
])

export const useDisableApplyMethod = (
  tabKey: TAB_KEYS = TAB_KEYS.PARAMETERS_COMPARISON
) => {
  const draftFilters = useSelector(
    (state: RootState) => state.dataAnalysis.byKey[tabKey]?.draft
  )
  const isApplyGlobally = useSelector(selectIsApplyGlobally)
  const globalDraftFilters = useSelector(selectGlobalDraftFilters)
  const { filter, messageField } = ApplyInfo[tabKey]

  const isApplyDisabled = useMemo(() => {
    const filtersToCheck = isApplyGlobally ? globalDraftFilters : draftFilters

    if (!filtersToCheck) {
      return true
    }

    const filterValue = filtersToCheck[filter]

    // Check if the filter has a valid value
    if (Array.isArray(filterValue)) {
      // For array filters (wheat_codes, blend_types, bins), check if array has items
      return filterValue.length === 0
    } else {
      // For single value filters (blend_type), check if value exists
      return (
        filterValue === undefined || filterValue === null || filterValue === ''
      )
    }
  }, [draftFilters, isApplyGlobally, globalDraftFilters, filter])

  return {
    isApplyDisabled,
    infoMessage: messageField,
  }
}
